import type { SVGProps } from "react";
import * as React from "react";

const SvgImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.293 15.707a1 1 0 0 0 1.414-1.414zM16 10l.707-.707a1 1 0 0 0-1.414 0zM5 4h14V2H5zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v14h2V5zm0 14a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H5v2h14zM5 20a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3zm-1-1V5H2v14zM4 5a1 1 0 0 1 1-1V2a3 3 0 0 0-3 3zm5 3.5a.5.5 0 0 1-.5.5v2A2.5 2.5 0 0 0 11 8.5zm-.5.5a.5.5 0 0 1-.5-.5H6A2.5 2.5 0 0 0 8.5 11zM8 8.5a.5.5 0 0 1 .5-.5V6A2.5 2.5 0 0 0 6 8.5zm.5-.5a.5.5 0 0 1 .5.5h2A2.5 2.5 0 0 0 8.5 6zm13.207 6.293-5-5-1.414 1.414 5 5zm-6.414-5-11 11 1.414 1.414 11-11z"
    />
  </svg>
);
export default SvgImage;
